let base = process.env.VUE_APP_SMALES_API_BASE

const api = (endpoint, data) => {
  if (data) {
    if (endpoint !== 'Values') {
      base = process.env.VUE_APP_SMALES_API_BASE
    }
    const headers = {
      'Content-Type': 'application/json'
    }
    if (endpoint !== 'WebLogin') {
      headers.Authorization = window.localStorage.getItem('token')
    }

    if (endpoint === 'UpdateProfile') {
      headers.customRequest = 'patch'
    }

    if (endpoint.indexOf('?') >= 0) {
      const [endpointPath, endpointQueries] = endpoint.split('?')

      endpoint = endpointPath + '.php?' + endpointQueries
    } else {
      endpoint += '.php'
    }

    return window.fetch(base + endpoint, {
      method: 'post',
      headers,
      body: JSON.stringify(data)
    })
      .then(res => {
        if (!res.ok) {
          return Promise.reject(res)
        }

        if (res.status === 204) {
          return
        }

        return res.json()
      })
  } else {
    if (endpoint === 'Values') {
      base = process.env.VUE_APP_PORTAL_API_BASE
    } else {
      base = process.env.VUE_APP_SMALES_API_BASE
    }

    if (endpoint.indexOf('?') >= 0) {
      const [endpointPath, endpointQueries] = endpoint.split('?')

      endpoint = endpointPath + '.php?' + endpointQueries
    } else {
      endpoint += '.php'
    }

    return window.fetch(base + endpoint, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': window.localStorage.getItem('token')
      }
    })
      .then(res => {
        if (!res.ok) {
          return Promise.reject(res)
        }

        return res.json()
      })
  }
}

export default api
